import { encode } from "iconv-lite";
import Papa from "papaparse";

export const exportCsv = (data: any[], dateNow: string, plugin: IPluginSettings) => {
    const result = renamedObject(data, plugin);
    
    const csvContent = Papa.unparse(result, {
      delimiter: ";",
    });
    
    const encoding = "win1251";
    const encodedContent = encode(csvContent, encoding);
    
    // Преобразуем Buffer в Uint8Array для совместимости с Blob
    const uint8Array = new Uint8Array(encodedContent);
    
    const blob = new Blob([uint8Array], { type: `text/csv;charset=${encoding}` });
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${plugin.name} ${dateNow}.csv`;
    document.body.appendChild(a);
    a.click();
    
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

const renamedObject = (data: any[], plugin: IPluginSettings) => {
    // Сортируем колонки по order
    const sortedColumns = [...plugin.columns].sort((a, b) => a.order - b.order);
    
    return data.map((value) => {
        const result: Record<string, any> = {};
        
        for (const column of sortedColumns) {
            // Пропускаем скрытые
            if (column.visibility === false) continue;
            // Пропускаем, если такого поля нет в данных
            if (!(column.propertyName in value)) continue;
            
            const newKey = column.displayName || column.propertyName;
            result[newKey] = value[column.propertyName];
        }

        return result;
    });
};